import type { Role } from "./api";

/**
 * How a role is written for a person to read.
 *
 * There were three copies of this - Home, Profile and the user list - and a
 * fourth set of the same words in the Add user form. Home no longer shows a
 * role at all (it greets you instead), so two screens read this now, which is
 * still two more than one. Same hazard as the
 * status badges: the API sends a role identifier and every screen was
 * inventing its own wording for it, so a rename would have left some screens
 * saying the old word.
 *
 * Typed as a total Record<Role, string>, so the compiler catches the role the
 * server grows next. test/ui-state-map.test.ts holds the other end: the SPA
 * cannot import src/lib/constants.ts, so a test reads this file and fails if
 * ROLES contains something with no label here.
 */
export const ROLE_LABELS: Record<Role, string> = {
  ADMIN: "Owner / Admin",
  STORE_MANAGER: "Store Manager",
  MARKETING: "Marketing",
  BILLING_EXECUTIVE: "Billing Executive",
  PAYMENT_COLLECTION_AGENT: "Payment Collection Agent",
  DELIVERY_AGENT: "Delivery Agent",
  SERVICE_MANAGER: "Service Manager",
  INDOOR_SERVICE_TECHNICIAN: "Indoor Service Technician",
  OUTDOOR_SERVICE_TECHNICIAN: "Outdoor Service Technician",
};

/**
 * The API types roles as plain strings in places, so this can miss at
 * runtime. Falling back to the identifier shows something true and ugly
 * rather than nothing at all.
 */
export function roleLabel(role: string | null | undefined): string {
  if (!role) return "";
  return ROLE_LABELS[role as Role] ?? role;
}
